import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  Clock,
  Ellipsis,
  Eye,
  Pencil
} from "lucide-react";
import { useState, type MouseEvent } from "react";
import { colorPrimary } from "../../theme";

interface TableActionsMenuProps {
  rowId: number;
  visualizarHistorico: (id: number) => void;
  visualiazarAnuncio: () => void;
  editar: () => void;
  excluir: () => void;
}

export function TableActionsMenuContaPagar({
  rowId,
  visualizarHistorico,
  visualiazarAnuncio,
  editar,
  excluir,
}: TableActionsMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        size="small"
        sx={{ 
          bgcolor: "#f9f9f9", 
          border: "1px solid rgba(40, 61, 107, 0.25)",
          "&:hover": { bgcolor: "#ffffff", borderColor: colorPrimary } 
        }}
      >
        <Ellipsis size={18} color="#6B7588" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            bgcolor: "#ffffff",
            color: "#121212",
            borderRadius: 2,
            minWidth: 200,
            border: "1px solid rgba(40, 61, 107, 0.25)",
            boxShadow: "0 16px 40px 5px rgb(0 0 0 / 20%)",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            visualizarHistorico(rowId);
            handleClose();
          }}
          sx={{
            "&:hover": { bgcolor: "rgba(255, 102, 0, 0.08)" }
          }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "#6B7588" }}>
            <Clock size={18} />
          </ListItemIcon>
          <ListItemText primary="Visualizar Histórico" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            visualiazarAnuncio();
            handleClose();
          }}
          sx={{
            "&:hover": { bgcolor: "rgba(6, 194, 112, 0.08)" }
          }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "#06c270" }}>
            <Eye size={18} />
          </ListItemIcon>
          <ListItemText primary="Visualizar Anúncio" />
        </MenuItem>

        <MenuItem
          onClick={() => {
            editar();
            handleClose();
          }}
          sx={{
            "&:hover": { bgcolor: "rgba(255, 102, 0, 0.08)" }
          }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: colorPrimary }}>
            <Pencil size={18} />
          </ListItemIcon>
          <ListItemText primary="Editar" />
        </MenuItem>
{/* 
        <MenuItem
          onClick={() => {
            excluir();
            handleClose();
          }}
          sx={{ 
            color: "#ff3b3b",
            "&:hover": { bgcolor: "rgba(255, 59, 59, 0.08)" }
          }}
        >
          <ListItemIcon sx={{ minWidth: 36, color: "#ff3b3b" }}>
            <Trash2 size={18} />
          </ListItemIcon>
          <ListItemText primary="Excluir" />
        </MenuItem> */}
      </Menu>
    </>
  );
}
